import React from 'react';
import Card from '../../../components/Card/CardTS';
import { loaderStyleEmptyCard } from '../../helpers/CustomStyles';
import Loading from '../../components/Loading/Loading';

type MapLoadingProps = {
	height?: number;
	testID?: string;
	transform?: number;
	width?: number;
};

const MapLoading = ({ height = 90, transform = 0.85, width = 70, testID = '' }: MapLoadingProps) => {
	return (
		<Card data-testid={testID}>
			<div style={loaderStyleEmptyCard}>
				<Loading height={height} transform={transform} width={width} color='gray' />
			</div>
		</Card>
	);
};

export default MapLoading;
